// @ts-nocheck
import React, { useState, useContext } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import type { SelectChangeEvent } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '../../../styles/ButtonTextStyle';
import LocalizationContext from '../../../../shared/contexts/LocalizationContext';
import LocalizationHelper from '../../../../helpers/TranslationHelper';
import { Localization, LocalizationEntity } from '../../../../shared/models/localization';
import { IPhaseDropdown } from '../../../models/IPhaseDropdown';

interface PhaseModalProps {
  phasesData: IPhaseDropdown[];
  isOpen: boolean;
  onClose: () => void;
  onMove: (selectedOption: number) => void;
}

const phaseModal: React.FC<PhaseModalProps> = ({ phasesData, isOpen, onClose, onMove }) => {
  const [selectedOption, setSelectedOption] = useState(phasesData[0].id);
  const localization = useContext<Array<LocalizationEntity>>(LocalizationContext);

  const handleOptionSelect = (phaseId: number) => {
    setSelectedOption(phaseId);
  };

  const handleMove = () => {
    onMove(selectedOption);
    onClose();
  };

  const moveText: string = LocalizationHelper.getLocaleEntityValue(
    localization,
    'ZSite.Frontend.Move',
    'Move'
  );

  const selectItems = phasesData.map((phase) => (
    <MenuItem value={phase.id} key={phase.id}>
      {phase.phaseName}
    </MenuItem>
  ));

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth={true}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            maxWidth: '492px',
          },
        },
      }}
    >
      <div className="dialog-header-container">
        <DialogTitle sx={{ fontWeight: '700' }}>Move to Phase</DialogTitle>

        <a onClick={onClose} className="cross-button">
          <span className="material-symbols-outlined">close</span>
        </a>
      </div>

      <DialogContent>
        <Select
          fullWidth={true}
          value={selectedOption}
          labelId="phase-dialog-select-label"
          input={<OutlinedInput />}
          onChange={(e: SelectChangeEvent<number>) => handleOptionSelect(e.target.value as number)}
          size="small"
          className="mb-3"
          sx={{ padding: '0.5% 0 0.5% 0' }}
        >
          {selectItems}
        </Select>
      </DialogContent>
      <ThemeProvider theme={theme}>
        <DialogActions>
          <Button
            variant="contained"
            color="info"
            onClick={handleMove}
            style={{ padding: '11px 35px 10px 35px' }}
          >
            {moveText}
          </Button>
        </DialogActions>
      </ThemeProvider>
    </Dialog>
  );
};

export const PhaseModal = React.memo(phaseModal);
